import { useMutation } from "@tanstack/react-query";

import { toast } from "@/components/toast/use-toast";

import { createYoutubeBlogPost } from "../fetch/blog.fetch";
import { queryKeys } from "./keys.query";

export function useYoutubeBlogPostMutation() {
  return useMutation({
    mutationKey: [queryKeys.createYoutubeBlogPost],
    mutationFn: (id: string) => createYoutubeBlogPost(id),
    onError: () => {
      toast({
        title: "Failed to create a blog post! Please log in to continue",
        variant: "destructive",
      });
    },
  });
}
